<div class="table-wrapper table-wrapper-full-page-height-permissions-table">
    <div class="permissions-container">
        <div class="permissions-container-item">
            <app-ag-table
                [name]="tableNameUserPermissions"
                [columnDefs]="columnDefsUserPermissions"
                [domLayout]="'normal'"
                [rowSelection]="rowSelection"
                [rowData]="userPermission"
                [isRowSelectable]="isRowSelectable"
                [getRowClass]="getRowClass"
                [suppressRowClickSelection]="true"
                (selectionChanged)="userPermissionsChange($event)"
            ></app-ag-table>
        </div>

        <div class="flex flex-column justify-content-center permission-buttons-container">
            <button pButton pRipple
                    *appCheckPermissions="permissionsService.permissions?.AdminUserPermissions?.AddPermissionToAdminUser"
                    [disabled]="!adminUserPermissionSelectedRow.length"
                    [label]="'Grant' | translate" (click)="addPermissionsToUser()"
                    icon="pi icon-left" class="p-button-primary">
            </button>
            <button pButton pRipple
                    *appCheckPermissions="permissionsService.permissions?.AdminUserPermissions?.RemovePermissionFromAdminUser"
                    [disabled]="!userPermissionSelectedRow.length"
                    [label]="'Remove' | translate" (click)="removePermissionsFromUser()" iconPos="right"
                    icon="pi icon-right" class="p-button-primary">
            </button>
        </div>

        <div class="permissions-container-item">
            <app-ag-table
                [name]="tableNameAdminUserPermissions"
                [columnDefs]="columnDefsAdminUserPermissions"
                [domLayout]="'normal'"
                [rowSelection]="rowSelection"
                [rowData]="adminUserPermission"
                [isRowSelectable]="isRowSelectable"
                [getRowClass]="getRowClass"
                [suppressRowClickSelection]="true"
                (selectionChanged)="adminUserPermissionsChange($event)"
            ></app-ag-table>
        </div>
    </div>
</div>
